module.exports = __webpack_public_path__ + "media/brands/yugo-886d229f.png";